<template>
    <v-dialog v-model="app.showUserSettings" max-width="600px">


      <v-card>
        <v-card-title>
            <v-layout justify-center="">
                <v-avatar color="primary" size="65">
                    <span class="white--text headline">{{user.initials}}</span>
                </v-avatar>
            </v-layout>
     


        </v-card-title>

            <core-loader v-if="user.initializing" ></core-loader>


            <v-container v-if="!user.initializing">
                <v-text-field

                    label="Huidige gebruiker"
                    disabled=""
                    v-model="user.name"/>
                <v-text-field
                    v-if="!userIsAdmin"
                    label="Actieve organisatie"
                    disabled=""
                    v-model="user.organisation.name"/>

                <settings-organisations v-if="userIsAdmin"/>

            </v-container>

            <v-expansion-panels
                v-if="!user.initializing"
                v-model="app.userSettingsPanel"
                flat
                hover
                multiple
                >
                <v-expansion-panel>
                    <v-expansion-panel-header>Wachtwoord aanpassen</v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <settings-user-change-password/>
                    </v-expansion-panel-content>
                </v-expansion-panel>      
            </v-expansion-panels>
      </v-card>

    </v-dialog>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  data: () => ({
    flat: true,
    hover: true
  }),
  computed: {
    ...mapState(["app", "user"]),
    ...mapGetters({ userIsAdmin: "user/userIsAdmin" })
  }
};
</script>

